import actions from "./actions";
import {setErrorReducer, setRequestReducer, setSuccessReducer} from "../helper";
import Big from "big.js";

const initState = {
    // Settings
    miniPosReadSettingsState: null,
    miniPosUpdateSettingsState: null,
    miniPosSettings: {},

    // Orders
    miniPosReadAllOrdersState: null,
    miniPosOrder: {},
    miniPosOrderSummaryData: {
        totalItems: 0,
        totalAmount: 0,
    },
    miniPosOrders: [],
    miniPosOrdersPagination: {},
    miniPosVoidOrderState: null,
    miniPosOrderStatus: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        // Read settings
        case actions.MINIPOS_READ_SETTINGS_REQUEST:
            return setRequestReducer(state, 'miniPosReadSettingsState');
        case actions.MINIPOS_READ_SETTINGS_SUCCESS:
            return setSuccessReducer(state, 'miniPosReadSettingsState', {
                miniPosSettings: action.settings,
            });
        case actions.MINIPOS_READ_SETTINGS_ERROR:
            return setErrorReducer(state, 'miniPosReadSettingsState');

        // Update settings
        case actions.MINIPOS_UPDATE_SETTINGS_REQUEST:
            return setRequestReducer(state, 'miniPosUpdateSettingsState');
        case actions.MINIPOS_UPDATE_SETTINGS_SUCCESS:
            return setSuccessReducer(state, 'miniPosUpdateSettingsState', {
                miniPosSettings: action.settings,
            });
        case actions.MINIPOS_UPDATE_SETTINGS_ERROR:
            return setErrorReducer(state, 'miniPosUpdateSettingsState');

        // Read all orders
        case actions.MINIPOS_READ_ALL_ORDERS_REQUEST:
            return setRequestReducer(state, 'miniPosReadAllOrdersState');
        case actions.MINIPOS_READ_ALL_ORDERS_SUCCESS:
            return setSuccessReducer(state, 'miniPosReadAllOrdersState', {
                miniPosOrders: action.orders,
                miniPosOrdersPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            });
        case actions.MINIPOS_READ_ALL_ORDERS_ERROR:
            return setErrorReducer(state, 'miniPosReadAllOrdersState');

        // Read order
        case actions.MINIPOS_READ_ORDER_REQUEST:
            return setRequestReducer(state, 'miniPosReadOrderState');
        case actions.MINIPOS_READ_ORDER_SUCCESS: {
            let totalItemsB = Big(0),
                totalAmountB = Big(0);

            action.order.products?.forEach(product => {
                totalAmountB = totalAmountB.add(Big(product.amount));
                totalItemsB = totalItemsB.add(Big(product.quantity));
            });

            return setSuccessReducer(state, 'miniPosReadOrderState', {
                miniPosOrder: {
                    ...action.order,
                    products: action.order.products?.map(product => ({
                        ...product,
                        unit_price: product.sale_price,
                    })),
                },
                miniPosOrderSummaryData: {
                    totalItems: totalItemsB.toNumber(),
                    totalAmount: totalAmountB.toNumber(),
                },
            });
        }
        case actions.MINIPOS_READ_ORDER_ERROR:
            return setErrorReducer(state, 'miniPosReadOrderState');

        // Void order
        case actions.MINIPOS_VOID_ORDER_REQUEST:
            return setRequestReducer(state, 'miniPosVoidOrderState');
        case actions.MINIPOS_VOID_ORDER_SUCCESS:
            return setSuccessReducer(state, 'miniPosVoidOrderState', {
                miniPosOrderStatus: action.status,
                miniPosOrder: {
                    ...action.order,
                    products: action.order.products?.map(product => ({
                        ...product,
                        unit_price: product.sale_price,
                    })),
                },
            });
        case actions.MINIPOS_VOID_ORDER_ERROR:
            return setErrorReducer(state, 'miniPosVoidOrderState');

        // Reset state
        case actions.MINIPOS_RESET_STATE:
            return {
                ...initState,
            };

        default:
            return state;
    }
}
